import { render } from "./RevenueBySlotsChart.vue?vue&type=template&id=210b43c5&scoped=true"
import script from "./RevenueBySlotsChart.vue?vue&type=script&lang=js"
export * from "./RevenueBySlotsChart.vue?vue&type=script&lang=js"

import "./RevenueBySlotsChart.vue?vue&type=style&index=0&id=210b43c5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210b43c5"]])

export default __exports__